import React from "react";
import styled from "styled-components";
import { Trans } from "@lingui/macro";
import {
  CommentOutline,
  Button,
  Menu,
  Popover,
  color,
  spacing,
  palette,
  typography,
} from "@conserveit/blocks";

// TODO: Legacy AddComment
import AddComment from "../../../containers/AddComment/AddComment";
import { WrapLegacyAddComment } from "../../Issues/components/IssuePane/IssuePane.styles";

import Loading from "../../Loading";
import { Half } from "../Action.styles";
import { Comment } from "./Comment";
import IssueModals from "../../IssueModals";

const Wrap = styled(Half)`
  background-color: ${palette.neutral2};
  border-left: 1px solid ${color.theme.divider.solid};
  padding: ${spacing.extraLoose};
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${spacing.default};
`;

const Title = styled.h3`
  display: inline-flex;
  align-items: center;
  margin: 0;
  ${typography.displaySmall}

  ${CommentOutline} {
    margin-right: ${spacing.tight};
  }
`;

const CommentPopover = styled(Popover)`
  width: 400px;
`;

export interface Comment {
  author?: string;
  author_name_display?: string;
  body: string;
  created: string;
  updated: string;
  id?: string;
  comment_id?: string;
}

interface Props {
  comments: Comment[];
  action: Insite.API.Action;
  isCommentsLoading: boolean;
}
export const CommentsColumn: React.FC<Props> = ({
  comments,
  action,
  isCommentsLoading,
}) => (
  <Wrap>
    {/* TODO: These components will be rebuilt */}
    <IssueModals />
    <Header>
      <Title>
        <CommentOutline />
        <Trans id="action_form.comments">Comments</Trans>
      </Title>
      <Menu noOffClickClose>
        {({ isOpen, close, toggle }) => (
          <React.Fragment>
            <Button additive wafer onClick={toggle}>
              <Trans id="action_form.add_comment">Add Comment</Trans>
            </Button>
            {isOpen && (
              <CommentPopover right>
                <WrapLegacyAddComment>
                  <AddComment
                    selected={action}
                    onAddComment={close}
                    onCancel={close}
                  />
                </WrapLegacyAddComment>
              </CommentPopover>
            )}
          </React.Fragment>
        )}
      </Menu>
    </Header>

    {isCommentsLoading && <Loading />}

    {/* TODO: This should be sorted by the API */}
    {!isCommentsLoading &&
      (comments.length === 0 ? (
        <Trans render="p" id="action_form.no_comments_yet">
          No comments yet
        </Trans>
      ) : (
        [...comments]
          .reverse()
          .map((comment) => (
            <Comment key={comment.comment_id || comment.id} comment={comment} />
          ))
      ))}
  </Wrap>
);
